import '../css/style.css'

export default function Content() {
    return(
        <div className='container'>
        <div className="homepage-about">
            <div className="logotitle">
                <div>MicroArt</div>
                <div className='logosubtitle'>Sztuka w każdym detalu</div>
            </div>
            <div className='content'>
                <p>
                <div className='listtitle'>Mikrocement Lublin – nowoczesne wnętrza z MicroArt</div>
                Witaj na stronie MicroArt Mikrocement Lublin – specjalistycznej firmy zajmującej się nowoczesnymi wykończeniami wnętrz z wykorzystaniem mikrocementu.
                    <br></br><br></br>
                Działamy głównie na terenie Lublina i województwa lubelskiego, a wybrane realizacje wykonujemy również w Warszawie i okolicach.
                    <br></br><br></br>
                Tworzymy przestrzenie, które zachwycają trwałością, estetyką i nowoczesnym stylem.
                    <br></br><br></br>
                Mikrocement pozwala uzyskać bezspoinowe, wodoodporne i eleganckie powierzchnie – idealne do łazienek, kuchni, salonów, schodów czy blatów.
                    <br></br><br></br>
                Efekt? Wnętrza, które przyciągają wzrok i zostają w pamięci.
                </p>
                <p>
                    <div className='listtitle'>Dlaczego MicroArt?</div>
                    <div>
                    MicroArt to mała, niezależna firma oparta na doświadczeniu, precyzji i uczciwej pracy.
                        <br></br><br></br>
                    Mikrocementem zajmujemy się na 100% – to nasza specjalizacja i codzienna praktyka.
                        <br></br><br></br>
                    Doświadczenie zdobywaliśmy w Belgi, gdzie mikrocement jest standardem w nowoczesnym wykończeniu wnętrz.
                        <br></br><br></br>
                    Teraz tę jakość przenosimy na grunt polski – łącząc europejski styl z lokalnym podejściem.
                        <br></br><br></br>
                    Realizujemy projekty w Lublinie, Świdniku, Nałęczowie, Lubartowie, a także w Warszawie i pobliskich miejscowościach.
                    </div>
                </p>
                <p><ul className='listcontainer'>
                    <div className='listtitle'>Nasze usługi:</div>
                    <li>Mikrocement na ścianach, podłogach i schodach</li>
                    <li>Mikrocement w łazienkach i kuchniach</li>
                    <li>Efekt chmury i struktury dekoracyjne</li>
                    <li>Mikrocement na blatach i meblach</li>
                    <li>Pomoc w wyborze koloru i struktury</li>
                </ul></p>
                <p>
                    <div className='listtitle'>Szukasz mikrocementu w Lublinie lub Warszawie?</div>
                    Dobrze trafiłeś. Skontaktuj się z nami, zobacz nasze realizacje i przekonaj się, jak nowoczesne może być Twoje wnętrze.<br></br>
                    <div className='listtitle'>MicroArt:<br></br> mikrocement, który robi różnicę.</div>
                </p>
                <p>
                    <div className='listtitle'>Działamy lokalnie – Mikrocement Lublin i okolice</div>
                    <div>
                    Nasza firma wykonuje mikrocement na terenie <strong>Lublina, Świdnika, Lubartowa, Nałęczowa i okolic</strong>.
                        <br></br><br></br>
                    Obsługujemy zarówno klientów prywatnych, jak i architektów wnętrz. Szukasz profesjonalnego wykonania mikrocementu w Lublinie? Skontaktuj się z nami!
                    </div>
                </p>
                <p>
                    <div className='listtitle'>MicroArt<br></br> Mikrocement Lublin</div>
                    Paweł Kozioł<br></br>
                    Lublin, Daliowa 17<br></br>
                    NIP: 7142047274<br></br>
                    Tel: +48 537 700 847 
                </p>
            </div>
        </div>
        </div>
    )
}